import client from "../client";

const saveClass = (props: any) => client.post<any>(`/trainings`, props);

const classApi = {
  saveClass,
};
export default classApi;
